// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jqepQ","message":"styles_message__Hd_2l","icon":"styles_icon__vuU8u","closeButton":"styles_closeButton__skyMr","label":"styles_label__elwtm"};